import * as React from 'react'

import { ReadAloudContent } from '../../../Shared/components/readAloud/readAloudContent'
import { useReadAloud } from '../../../Shared/components/readAloud/readAloudContext'
import { SPOKEN_WORD_ATTRIBUTE, UNSPOKEN_CLASS } from '../../../Shared/libs/speech/speechText'

const readExampleSrc = `${window.postbuildEnv.CDN_URL}/images/illustrations/proofreader-example-proofread.svg`
const reviewExampleSrc = `${window.postbuildEnv.CDN_URL}/images/illustrations/proofreader-example-review.svg`
const practiceExampleSrc = `${window.postbuildEnv.CDN_URL}/images/illustrations/proofreader-example-practice.svg`

const WelcomePage = ({onNextClick}) => {
  const { readAloudEnabled, } = useReadAloud()
  const stepNumberClass = readAloudEnabled ? `step-number ${UNSPOKEN_CLASS}` : 'step-number'
  const read = readAloudEnabled ? <span {...{ [SPOKEN_WORD_ATTRIBUTE]: 'Reed', }}>Read</span> : 'Read'

  return (
    <div className="welcome-page">
      <ReadAloudContent label="Read this page aloud">
        <div className="header-section">
          <h1>Welcome to Quill Proofreader!</h1>
        </div>
        <div className="steps-section">
          <div className="step">
            <div className={stepNumberClass}>1</div>
            <h2>{read}</h2>
            <p>{read} the passage and correct the <br />grammar and punctuation <br />errors you find.</p>
            <img alt="Proofreader example showing a potential grammar mistake highlighted" src={readExampleSrc} />
          </div>
          <div className="step">
            <div className={stepNumberClass}>2</div>
            <h2>Review</h2>
            <p>Get feedback on each <br />correction you made.</p>
            <img alt="Proofreader example showing a correct and incorrect revision" src={reviewExampleSrc} />
          </div>
          <div className="step">
            <div className={stepNumberClass}>3</div>
            <h2>Improve</h2>
            <p>Work on a follow-up activity that focuses on one of the errors <br />from the passage.</p>
            <img alt="Follow-up example showing a correct revision" src={practiceExampleSrc} />
          </div>
        </div>
      </ReadAloudContent>
      <div id="button-container" tabIndex={-1}>
        <button className="quill-button large contained green focus-on-light" onClick={onNextClick} type="button">Next</button>
      </div>
    </div>
  )
}

export default WelcomePage
